import React from 'react';
import { Building2, Heart, Stethoscope, Landmark, GraduationCap, Award, Globe, Instagram } from 'lucide-react';
const PILLS = [{
  icon: Building2,
  label: 'Empresas'
}, {
  icon: Heart,
  label: 'Fundaciones'
}, {
  icon: Stethoscope,
  label: 'Profesionales de Salud'
}, {
  icon: Landmark,
  label: 'Entidades Gubernamentales'
}, {
  icon: GraduationCap,
  label: 'Instituciones Educativas'
}, {
  icon: Award,
  label: 'Marcas Comprometidas'
}];
interface AllyLink {
  type: 'web' | 'instagram';
  label: string;
  href: string;
}
interface Ally {
  initials: string;
  badge: string;
  name: string;
  role: string;
  description: string;
  photo?: string;
  /** Use "contain" on a white backdrop for logos, "cover" for photos. */
  photoFit?: 'cover' | 'contain';
  links?: AllyLink[];
}
const ALLIES: Ally[] = [{
  initials: 'DB',
  badge: 'NEURODESARROLLO',
  name: 'Developing Brains',
  role: 'Liudmila Guas & Dr. Mauricio Chinchilla',
  description: 'Organización especializada en neurología y neurodesarrollo infantil. 3 años de colaboración continua.',
  photo: 'https://cdn.magicpatterns.com/uploads/cY7fwsA78qWX3c29SXDCni/developingbrain.png',
  photoFit: 'contain',
  links: [{
    type: 'web',
    label: 'Sitio web',
    href: 'https://www.thedevelopingbrains.com/en'
  }, {
    type: 'instagram',
    label: 'Instagram',
    href: 'https://www.instagram.com/mauriciochinchillaacosta'
  }]
}, {
  initials: 'AM',
  badge: 'PEDIATRÍA',
  name: 'Dr. Andrés Marcano',
  role: 'Pediatra especializado',
  description: 'Especialista en autismo y TDAH, referente en la comunidad latina de Florida',
  photo: 'https://cdn.magicpatterns.com/uploads/1c5yryqUHvdDCSgWA94E6G/ChatGPT_Image_Jun_16,_2026,_05_04_18_PM.png',
  links: [{
    type: 'instagram',
    label: 'Instagram',
    href: 'https://www.instagram.com/mipediatratea'
  }]
}, {
  initials: 'LJ',
  badge: 'PSICOLOGÍA',
  name: 'Lorena Jiménez',
  role: 'Famikids',
  description: 'Psicología infantil y familiar para el acompañamiento integral del núcleo familiar',
  photo: 'https://cdn.magicpatterns.com/uploads/aq92akbqEpG8wVGVsguX7e/ChatGPT_Image_Aug_3,_2026,_11_49_41_PM.png',
  links: [{
    type: 'instagram',
    label: 'Instagram',
    href: 'https://www.instagram.com/famikids'
  }]
}, {
  initials: 'LG',
  badge: 'EDUCACIÓN',
  name: 'Dra. Lenys González-Valles',
  role: 'Gastroenteróloga · Autismo y Salud Intestinal',
  description: 'Gastroenteróloga experta en autismo y salud intestinal. Autora del primer estudio latinoamericano sobre salud intestinal en niños con autismo. Su colaboración es a través de charlas y conferencias educativas para padres. En alianza con Nutritea_ve y la Lic. Lizmary García.',
  photo: 'https://cdn.magicpatterns.com/uploads/4beaMscpGiMQYXhLbojAzT/ChatGPT_Image_Jun_16,_2026,_04_57_38_PM.png',
  links: [{
    type: 'instagram',
    label: 'Instagram',
    href: 'https://www.instagram.com/drlenysgonzal'
  }]
}];
const PINEYRO_PHOTO = '';
export function AlliesShowcase() {
  return <>
      {/* Ally categories */}
      <section className="mp-allies-pills-section" style={{
      background: 'white',
      padding: '60px 20px'
    }} data-id="element-21" data-mp="1xkuw1jl9qwiu">
        <p style={{
        color: '#7DC920',
        fontSize: '11px',
        letterSpacing: '3px',
        fontWeight: 700,
        textAlign: 'center',
        marginBottom: '8px'
      }} data-id="element-22" data-mp="1st3e1xg6hz4b">
          NUESTROS ALIADOS
        </p>
        <h2 className="mp-allies-pills-title" style={{
        fontSize: '32px',
        fontWeight: 800,
        color: '#1a1a1a',
        textAlign: 'center',
        marginBottom: '12px'
      }} data-id="element-23" data-mp="1etbuziat1sjg">
          Nuestros Aliados
        </h2>
        <p style={{
        fontSize: '15px',
        color: '#666',
        textAlign: 'center',
        marginBottom: '40px'
      }} data-id="element-24" data-mp="3evuyh3hzukcu">
          Trabajamos con empresas, fundaciones y profesionales comprometidos con
          la familia
        </p>
        <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: '12px',
        maxWidth: '700px',
        margin: '0 auto'
      }} data-id="element-25" data-mp="2r68y4cpvxz39">
          {PILLS.map(({
          icon: Icon,
          label
        }) => <span key={label} className="mp-ally-pill" style={{
          background: '#f0fae8',
          border: '1.5px solid #c8eaa0',
          color: '#2d5a1b',
          padding: '10px 20px',
          borderRadius: '30px',
          fontSize: '14px',
          fontWeight: 600,
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px'
        }} data-id="element-26" data-mp="2m7fjui2ry421">
              <Icon size={15} color="currentColor" data-id="element-27" data-mp="2eprfx9i4f8pm" />
              {label}
            </span>)}
        </div>
      </section>

      {/* Ally network */}
      <section className="mp-allies-network-section" style={{
      background: '#f9fdf5',
      padding: '60px 20px'
    }} data-id="element-28" data-mp="2npe772h4yy4y">
        <h2 className="mp-allies-title" style={{
        fontSize: '28px',
        fontWeight: 800,
        color: '#1a1a1a',
        textAlign: 'center',
        margin: '0 0 32px'
      }} data-id="element-29" data-mp="2iprrmmdu55sz">
          Nuestra Red de Aliados
        </h2>
        <div className="mp-allies-photo-grid" style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: '20px',
        maxWidth: '960px',
        margin: '0 auto'
      }} data-id="element-30" data-mp="13a2syi4va9ot">
          {ALLIES.map(ally => <article key={ally.name} className="mp-ally-card" style={{
          background: 'white',
          borderRadius: '16px',
          overflow: 'hidden',
          boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
          border: '1px solid #f0f0f0',
          position: 'relative'
        }} data-id="element-31" data-mp="1s0p7vy5l1kgn">
              <div style={{
            position: 'relative',
            width: '100%'
          }} data-id="element-32" data-mp="2axi1xwmkqpc1">
                <div style={{
              width: '100%',
              height: '220px',
              background: ally.photo && ally.photoFit === 'contain' ? 'white' : 'linear-gradient(135deg, #1a3a0a 0%, #2d5a1b 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden',
              position: 'relative'
            }} data-id="element-33" data-mp="2kol12svy0u8o">
                  {ally.photo ? ally.photoFit === 'contain' ? <img src={ally.photo} alt={ally.name} style={{
                maxWidth: '70%',
                maxHeight: '140px',
                width: 'auto',
                height: 'auto',
                objectFit: 'contain',
                objectPosition: 'center center',
                display: 'block',
                margin: '0 auto'
              }} data-id="element-34" data-mp="44irt8j10anf" /> : <img src={ally.photo} alt={ally.name} style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                objectPosition: 'center 20%',
                display: 'block'
              }} data-id="element-35" data-mp="1foej7vsyjk7h" /> : <span aria-hidden="true" style={{
                width: '80px',
                height: '80px',
                minWidth: '80px',
                minHeight: '80px',
                borderRadius: '50%',
                background: 'white',
                border: '3px solid #7DC920',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                boxShadow: '0 4px 16px rgba(0,0,0,0.3)'
              }} data-id="element-36" data-mp="17q3ydmm9wo8o">
                      <span style={{
                  display: 'block',
                  fontSize: '26px',
                  fontWeight: 900,
                  color: '#2d5a1b',
                  lineHeight: 1,
                  textAlign: 'center'
                }} data-id="element-37" data-mp="3azfho6kmkfvi">
                        {ally.initials}
                      </span>
                    </span>}
                </div>
                <span style={{
              position: 'absolute',
              bottom: '-13px',
              left: '16px',
              zIndex: 10,
              background: 'white',
              border: '1.5px solid #c8eaa0',
              borderRadius: '20px',
              padding: '4px 14px',
              fontSize: '10px',
              fontWeight: 700,
              letterSpacing: '1.5px',
              color: '#2d5a1b',
              whiteSpace: 'nowrap',
              boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
            }} data-id="element-38" data-mp="3602wdq9ejgv1">
                  {ally.badge}
                </span>
              </div>
              <div style={{
            padding: '28px 20px 20px'
          }} data-id="element-39" data-mp="ij3ibdhkyddr">
                <h3 style={{
              fontSize: '16px',
              fontWeight: 700,
              color: '#1a1a1a',
              marginTop: '8px',
              marginBottom: '4px'
            }} data-id="element-40" data-mp="8r7k82fhun9j">
                  {ally.name}
                </h3>
                <p style={{
              fontSize: '13px',
              color: '#7DC920',
              fontWeight: 600,
              marginBottom: '8px'
            }} data-id="element-41" data-mp="3qx3reath50lr">
                  {ally.role}
                </p>
                <p style={{
              fontSize: '13px',
              color: '#666',
              lineHeight: 1.5,
              marginBottom: '12px'
            }} data-id="element-42" data-mp="26e9yhoshfsh4">
                  {ally.description}
                </p>
                {ally.links && <div style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '12px',
              paddingTop: '12px',
              borderTop: '1px solid #f0f0f0'
            }} data-id="element-43" data-mp="1iqiahnxkxr00">
                    {ally.links.map(link => <a key={link.href} href={link.href} target="_blank" rel="noopener noreferrer" style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '4px',
                fontSize: '12px',
                color: '#7DC920',
                fontWeight: 600,
                textDecoration: 'none'
              }} data-id="element-44" data-mp="z1hnw6e6dtbt">
                        {link.type === 'instagram' ? <Instagram size={12} data-id="element-45" data-mp="1ocmf2t2ywd8k" /> : <Globe size={12} data-id="element-46" data-mp="1jekwsadd8hy5" />}
                        {link.label}
                      </a>)}
                  </div>}
              </div>
            </article>)}
        </div>

        <div className="mp-pineyro-card" style={{
        background: '#f0fae8',
        border: '1.5px solid #7DC920',
        borderRadius: '14px',
        padding: '24px 32px',
        display: 'flex',
        alignItems: 'center',
        gap: '24px',
        maxWidth: '960px',
        margin: '20px auto 0',
        overflow: 'hidden',
        position: 'relative'
      }} data-id="element-47" data-mp="38rxtbdf8l1op">
          <div style={{
          width: '80px',
          height: '80px',
          borderRadius: '50%',
          overflow: 'hidden',
          flexShrink: 0,
          background: '#2d5a1b',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '3px solid #7DC920'
        }} data-id="element-48" data-mp="32ds9rrya6ah1">
            {PINEYRO_PHOTO ? <img src={PINEYRO_PHOTO} alt="Concejal Rafael Pineyro" style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover'
          }} data-id="element-49" data-mp="3q9mwjhe5mnqy" /> : <Award size={28} color="white" data-id="element-50" data-mp="mmmg3d4cjwfn" />}
          </div>
          <div data-id="element-51" data-mp="2u5pjvnijkmq5">
            <p style={{
            fontSize: '18px',
            fontWeight: 700,
            color: '#1a1a1a'
          }} data-id="element-52" data-mp="2u21o0hpmjo89">
              Concejal Rafael Pineyro
            </p>
            <p style={{
            color: '#7DC920',
            fontWeight: 600,
            fontSize: '14px',
            margin: '4px 0'
          }} data-id="element-53" data-mp="2g4v9x0fuidpd">
              Ciudad de Doral — Impacto Social e Institucional
            </p>
            <p style={{
            fontSize: '14px',
            color: '#444'
          }} data-id="element-54" data-mp="342kevwflw4zo">
              Respaldo institucional de la Ciudad de Doral para los programas y
              eventos de la fundación
            </p>
          </div>
        </div>

        <p style={{
        fontSize: '12px',
        color: '#999',
        textAlign: 'center',
        fontStyle: 'italic',
        marginTop: '24px'
      }} data-id="element-55" data-mp="fa8u5oo18j7">
          * Todos los aliados han dado autorización para aparecer en este sitio
        </p>
      </section>
    </>;
}